import * as React from 'react';
import { TextButton } from 'wix-ui-tpa';
import { st, classes } from './ExpandedGoogleCopy.st.css';
import { useTranslation } from 'react-i18next';
import { DEMO_CALENDARS_IDS } from '../../../constants';
import getDemoCopyLink from '../../../utils/getDemoCopyLink';
var openLink = function (link) { return window.open(link); };
var ExpandedGoogleCopy = function (_a) {
    var isMobile = _a.isMobile, expandedEventsProps = _a.expandedEventsProps, title = _a.title;
    var isDetailsVisible = expandedEventsProps.isDetailsVisible, copyLink = expandedEventsProps.copyLink, onCopyClick = expandedEventsProps.onCopyClick, calendarId = expandedEventsProps.calendarId;
    var t = useTranslation()[0];
    var isDemoCalendar = DEMO_CALENDARS_IDS.includes(calendarId);
    var _onCopyClick = function () {
        if (isDemoCalendar) {
            openLink(getDemoCopyLink(expandedEventsProps, t, title));
        }
        else {
            openLink(copyLink);
        }
        onCopyClick && onCopyClick();
    };
    return (React.createElement(React.Fragment, null, isDetailsVisible && copyLink ? (React.createElement("div", { className: st(classes.CopyToGoogleWrapper, { isMobile: isMobile }) },
        React.createElement(TextButton, { onClick: _onCopyClick, onKeyUp: function (e) { return e.key === 'Enter' && _onCopyClick(); }, className: st(classes.CopyToGoogle, { isMobile: isMobile }), tabIndex: 1 }, t('Google_Calendar_Copy')))) : null));
};
export default React.memo(ExpandedGoogleCopy);
//# sourceMappingURL=ExpandedGoogleCopy.js.map